import AppConstants from '../config/app.constants';

let CustomerService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/customer`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/customer/create`, { data, branchId, userId })
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/customer/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/customer/${id}`, { data, branchId, userId })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/customer/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getSurchargeConfigBulk = (customerIds) => {
        return $http
            .get(AppConstants.api + `/customer/surcharge-config-bulk`, {
                params: {
                    customerIds: (customerIds || []).join(',')
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getSurchargeHistory = (customerId) => {
        return $http
            .get(AppConstants.api + `/customer/${customerId}/surcharge-history`)
            .then((res) => {
                return res.data
            })
    }

    let getCustomerLocationHistory = (searchText, customerId, sortASC, sortColumn, offset, limit,) => {
        return $http
            .get(AppConstants.api + `/customer/${customerId}/get-customer-location-history`, {
                params: {
                    searchText,
                    customerId,
                    sortASC,
                    sortColumn,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCustomerContractHistory = (searchText, customerId, sortASC, sortColumn, offset, limit,) => {
        return $http
            .get(AppConstants.api + `/customer/${customerId}/get-customer-contract-history`, {
                params: {
                    searchText,
                    customerId,
                    sortASC,
                    sortColumn,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getBillingRulesInfo = (languageId, contractInfo) => {
        return $http
            .get(AppConstants.api + `/customer/get-billing-rules-info`, {
                params: {
                    languageId,
                    contractInfo
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let customerPickupReport = (searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/customer/customer-pickup-report`, {
                params: {
                    searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, limit, offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportCustomerPickupReport = (searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, branchTimeZone) => {
        return $http
            .post(AppConstants.api + `/customer/export-customer-pickup-report`, {
                    searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, branchTimeZone
            })
            .then((res) => {
                return res.data
            })
    }

    let uploadContractDocument = (files, customerId, branchId) => {
        return $http
            .post(AppConstants.api + `/customer/upload-contract-document`, { files, customerId, branchId })
            .then((res) => {
                return res.data
            })
    }

    let getUploadedDocument = (customerId) => {
        return $http
            .get(AppConstants.api + `/customer/get-contract-files`, {
                params: {
                    customerId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let downloadContractDocument = (customerId, fileName) => {
        return new Promise(function (resolve, reject) {
            const url = (AppConstants.api + `/customer/download-contract-document`)
            const xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            const data = { customerId, fileName };

            xhr.onload = function () {
                if (this.status === 200) {
                    const blob = new Blob([xhr.response]);
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = fileName;
                    a.click();
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        })
    }

    let deleteContractDocument = (customerId, fileName, branchId) => {
        return $http
            .post(AppConstants.api + `/customer/delete-contract-document`, { customerId, fileName, branchId })
            .then((res) => {
                return res.data
            })
    }

    let viewContractDocument = (customerId, fileName) => {
        return new Promise(function (resolve, reject) {
            const url = (AppConstants.api + `/customer/view-contract-document`)
            const xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            const data = { customerId, fileName };

            xhr.onload = function () {
                if (this.status === 200) {
                    const blob = new Blob([xhr.response], { type: "application/pdf" });
                    const windowURL = URL.createObjectURL(blob);
                    window.w = window.open(windowURL, '_blank');
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        })
    }
    
    let exportCustomerLocationHistory = (customerId, searchText, sortASC, sortColumn) => {
        return $http
            .post(AppConstants.api + `/customer/export-customer-location-history`, {
                customerId, searchText, sortASC, sortColumn
            })
            .then((res) => {
                return res.data
            })
    }
    
    let exportCustomerLocationBillingRule = (customerId, contractId) => {
        return $http
            .post(AppConstants.api + `/customer/export-customer-location-billing-rule`, {
                customerId, contractId
            })
            .then((res) => {
                return res.data
            })
    }

    let getCustomerContractData = (contractTypeId, customerId) => {
        return $http
            .get(AppConstants.api + `/customer/get-customer-contract-data`, {
                params: { contractTypeId, customerId }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        getSurchargeConfigBulk,
        getSurchargeHistory,
        getCustomerLocationHistory,
        getCustomerContractHistory,
        getBillingRulesInfo,
        customerPickupReport,
        exportCustomerPickupReport,
        uploadContractDocument,
        getUploadedDocument,
        downloadContractDocument,
        deleteContractDocument,
        viewContractDocument,
        exportCustomerLocationHistory,
        exportCustomerLocationBillingRule,
        getCustomerContractData
    };
};

CustomerService.$inject = ['$http', '$q']

export default CustomerService;



// WEBPACK FOOTER //
// ./client/app/services/customer.service.js